module.exports = __webpack_public_path__ + "396f4ec689d55b477922fb03a44aa5b7.png";